import {
    BrandDataProps,
    ProductMaterialProps,
    ProductTypeDataProps,
    ProductTypeProps,
    SpecxColorsData,
} from "../interface";

const useDropDown = () => {
    const getDropdown = <T extends Record<string, any>>(
        response: T[]
    ): ProductTypeProps[] => {
        return response.map((value) => ({
            value: value.id || value.product_type?.id,
            label:
                value.name ||
                value.brand_name ||
                value.color_name ||
                value.product_type?.name,
            code:
                value.brand_code ||
                value.product_type_initials ||
                value.product_type?.product_type_initials,
            brandType: value.brand_type || 1,
        }));
    };

    const getProductTypeDropdown = (
        response: ProductTypeDataProps[]
    ): ProductTypeProps[] => {
        return response
        .filter((value)=> value.product_type.name !== 'Lens')
        .map((value) => ({
            value: value.product_type.id,
            label: value.product_type.name,
            code: value.product_type.product_type_initials,
        }));
    };

    const getBrandDropdown = (response: BrandDataProps[]): ProductTypeProps[] => {
        return response.map((value) => ({
            value: value.id,
            label: value.brand_name,
            code: value.brand_code,
        }));
    };

    const getSpecxColorDropdown=(response:SpecxColorsData[]):ProductTypeProps[]=>{
        return response?.map((value) => ({
            value: value.id,
            label: value.color_name || 'hgfjhg',
            code: value.color_name,
        }));
    }

    const getProductMaterialDropdown=(response:ProductMaterialProps[]):ProductTypeProps[]=>{
        return response?.map((value) => ({
            value: value.id,
            label: value.name,
            code: value.name,
        }));
    }

    // for find the required array
    const findArrayForDefaultValue = <T extends { value: string }>(
        ids: string[],
        data: T[]
      ): T[] =>
        ids.reduce<T[]>((acc, id) => {
          const match = data?.find((item) => item?.value === id);
          return match ? [...acc, match] : acc;
        }, []);
      
      

    return {
        getDropdown,
        getProductTypeDropdown,
        getBrandDropdown,
        getSpecxColorDropdown,
        getProductMaterialDropdown,
        findArrayForDefaultValue
    };
};

export default useDropDown;
